import { EventDetails } from 'sections/Events/components/EventDetails/EventDetails.types';

export const eventDetailsData: EventDetails[] = [
  {
    id: 1,
    img: '/images/pages/Events/icon-calendar.svg',
    text: '10 March 2022 — 11 March 2022',
  },
  {
    id: 2,
    img: '/images/pages/Events/icon-location.svg',
    text: 'DP World Flow Pavilion at Expo 2020',
  },
  {
    id: 3,
    text: 'Dubai, United Arab Emirates',
    link: 'https://www.google.com.ua/maps/place/%D0%94%D1%83%D0%B1%D0%B0%D0%B9+-+%D0%9E%D0%B1%D1%8A%D0%B5%D0%B4%D0%B8%D0%BD%D0%B5%D0%BD%D0%BD%D1%8B%D0%B5+%D0%90%D1%80%D0%B0%D0%B1%D1%81%D0%BA%D0%B8%D0%B5+%D0%AD%D0%BC%D0%B8%D1%80%D0%B0%D1%82%D1%8B/@25.0620108,54.798968,8.4z/data=!4m5!3m4!s0x3e5f43496ad9c645:0xbde66e5084295162!8m2!3d25.2048493!4d55.2707828?hl=ru',
  },
];